module.exports = __webpack_public_path__ + "img/logo_blue.6330cb83.svg";